import { TrackingInfo } from '../../client/services/types';

export const initialState = Object.freeze({
  barcode: '',
  trackingList: [] as TrackingInfo[],
});

export type TrackingState = typeof initialState;
